import $ from 'wee-dom';
import $events from 'wee-events';
import $fetch from 'wee-fetch';
import { RouteHandler } from 'wee-routes';
import { _body } from 'core/variables';
import KeyHelper from '../../scripts/keyhelper';
import Tabbable from '../../scripts/tabbable';
import emailResponse from './email-response-template';

class Newsletter {
    constructor() {
        this.$body = $(_body);
        this.$popup = $(':newsletterPopup');
        this.$email = $(':newsletterEmail');
        this.$emailConfirm = $(':newsletterEmailConfirm');
        this.$emailConfirmMessage = $(':confirmationMessage');
        this.$allCheckboxes = $(':checkbox');
        this.$lewisHospitals = $(':lewis-hospitals');
        this.$lewisCom = $(':lewis-com');
        this.required = '-required';
        this.confirm = '-confirm';
        this.tabbable = null;
        this.popupClass = '-popup';
        this.$response = $(emailResponse());
    }

    openPopup($el) {    
        this.$popup.show();
        this.$body.addClass(this.popupClass);
        this.$email.val($el.val());
        $el.val('');

        if (! this.$email.val()) {
            this.$email[0].focus();
        } else {
            this.$emailConfirm[0].focus();
        }

        this.tabbable = new Tabbable({
            el: this.$popup,
            callback: () => {
                this.tabbable.$firstEl[0].focus();
            }
        });
    }

    closePopup() {
        this.$popup.hide();
        this.$body.removeClass(this.popupClass);
        this.$emailConfirm.val('');
        this.setCheckedValue(this.$allCheckboxes, true);
        this.tabbable.destroy();
    }

    submit() {
        if (this.isFormValid()) { 
            // get check value on check checkboxes
            const hospitalsLists = this.getSelectedItems(this.$lewisHospitals);
            const comLists = this.getSelectedItems(this.$lewisCom);

            // create and set params object
            const params = {
                email: this.$email.val(),
            };

            // Create account list params
            if (hospitalsLists.length) {
                params.lewis_hospitals = hospitalsLists;
            }

            if (comLists.length) {
                params.lewis_com = comLists;
            }

            this.addContact(params);
        } else {
            if (! this.isEmailValid()) {
                this.$emailConfirmMessage.addClass(this.required);
            } else if (! this.getSelectedItems(this.$allCheckboxes).length) {
                $(':requiredCheckboxMessage').addClass(this.required);
            }
        }
    }

    /**
     * Returns object of new or existing contact
     * @param {object}  - Object of params passed to post request
     */
    addContact(params) {
        $fetch({
            method: 'get',
            url: `${window.location.origin}/trigger/constant-contact-module/default`,
            params: params,
            send: () => {
                // Cose Form Popup
                this.closePopup();
                this.responseMessage();
            }
        })
        .then(response => {
            // Close response popup
            this.$response.removeClass('-request');

            setTimeout(() => {
                this.$body.removeClass(this.popupClass);
                this.$response.remove();
            }, 3200);

            return response;
        }).catch(error => console.error(error));
    }

    responseMessage() {
        // Create reponse popup
        this.$body.addClass(this.popupClass);
        this.$body.append(this.$response);
        this.$response.addClass('-request');
    }

    /**
     * Returns string of slected list ids
     * @param {array} - array of checkbox selectors
     */
    getSelectedItems($checkboxes) {
        let ids = [];

            for (let i = 0; i < $checkboxes.length; i++) {
                const box = $checkboxes[i];

                if (box.checked) {
                    ids.push($(box).val());
                }
            }
        return ids.toString();
    }

    isEmailValid() {
        if (this.$email.val().match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
            return true;
        } else {
            return false;
        }
    }

    confirmEmail() {
        if (! this.isEmailValid()) {
            this.$emailConfirmMessage.addClass(this.required);
        } else if (! this.isEmailMatched()) {
            this.$emailConfirmMessage.addClass(this.confirm);
        } else {
            this.$emailConfirmMessage.removeClass(this.confirm);
            this.$emailConfirmMessage.removeClass(this.required);
        }
    }

    selectAll(el) {
        if (el.checked) {
            this.setCheckedValue(this.$allCheckboxes, el.checked);
        } else {
            this.setCheckedValue(this.$allCheckboxes, el.checked);
        }
    }

    clearSelection() {
        this.setCheckedValue(this.$allCheckboxes, false);
    }

    setCheckedValue($checkboxes, value) {
        $checkboxes.map(item => item.checked = value);
    }

    isEmailMatched() {
        return this.$email.val() === this.$emailConfirm.val();
    }

    isFormValid() {
        return this.isEmailMatched() && this.isEmailValid() && this.getSelectedItems(this.$allCheckboxes).length;
    }

    isOpen() {
        return this.$body.hasClass(this.popupClass);
    }
}

export default new RouteHandler({
    init() {
        let newsletter = new Newsletter;
        
        $events.on({
            ':signupBtn': {
                click(e, el) {
                    newsletter.openPopup($(el).siblings(':signupInput'));

                    $events.on(_body, 'click.newsletterPopup', (e, el) => {
                        if (e.target === el) {
                            newsletter.closePopup();
                            $events.off('.newsletterPopup');
                        }
                    });
                    e.preventDefault();
                }
            },
            ':newsletterEmailConfirm': {
                blur() {
                    newsletter.confirmEmail();
                }
            },
            ':selectAllLists': {
                change(e, el) {
                    newsletter.selectAll(el);
                    e.preventDefault();
                }
            },
            ':clearSelection': {
                click(e) {
                    newsletter.clearSelection();
                    e.preventDefault();
                }
            },
            ':newsletterSubmit': {
                click(e) {
                    newsletter.submit();
                    e.preventDefault();
                }
            },
            ':newsletterClose': {
                click() {    
                    newsletter.closePopup();
                },
                keypress(e) {
                    if (KeyHelper.isEnter(e)) {
                        newsletter.closePopup();
                    }
                }
            },
            body: {
                keydown(e) {
                    if (newsletter.isOpen() && KeyHelper.isEsc(e)) {
                        newsletter.closePopup();
                    }
                }
            }
        });
    }
});
